// ブランドカラーの単一真実源。
// 値はビルド時の環境変数で注入し、テナント(kumanote / AXceed 等)ごとに切替える。
// GitHub Environments の Variables で各テナントの値を設定する想定 (pages.yml 参照)。
//
// 重要: 未設定時のフォールバックは既存 kumanote の tan 系を維持する。
//       これにより環境変数が未設定でも kumanote の表示は壊れない(鉄則: 既存を壊さない)。
//       AXceed では REACT_APP_PRIMARY_COLOR 等を青系に設定して上書きする。
export const colors = {
  /** ブランド主色（kumanote 既定 #d7b27a）。ダイアログ見出し・主要ボタン等 */
  primary: process.env.REACT_APP_PRIMARY_COLOR || "#d7b27a",
  /** 補助/セカンダリ（kumanote 既定 #c1c1a4）。ログインボタンの文字・枠線等 */
  secondary: process.env.REACT_APP_SECONDARY_COLOR || "#c1c1a4",
  /** アクセント（kumanote 既定 teal #80c3c6）。一覧画面のアクションボタン等 */
  accent: process.env.REACT_APP_ACCENT_COLOR || "#80c3c6",
} as const;
